import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
	IonButton,
	IonCard,
	IonCardContent,
	IonContent,
	IonHeader,
	IonIcon,
	IonTitle,
	IonToolbar
} from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'app-nova-portal-error-page',
	templateUrl: './error.page.html',
	styleUrls: ['./error.page.scss'],
	imports: [
		IonButton,
		IonCard,
		IonCardContent,
		IonContent,
		IonHeader,
		IonIcon,
		IonTitle,
		IonToolbar,
		RouterLink,
		TranslateDirective,
		TranslatePipe
	]
})
export class ErrorPage {
	constructor() {}
}
